import getLocalString from "constants/Localization";
import {
  useAddProposalStageChecklistItemsMutation,
  AddProposalStageChecklistItemsInput,
} from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useAddProposalStageChecklistItems() {
  const [mutation, { loading, data, error }] = useAddProposalStageChecklistItemsMutation({
    refetchQueries: ["getProposal"],
  });

  const [addProposalStageChecklistItems, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "addProposalStageChecklistItems",
    },
    {
      successMessage: getLocalString("proposals.add-stage-checklist-items-success"),
      failureMessage: getLocalString("proposals.add-stage-checklist-items-failure"),
    }
  );

  const addChecklistItems = (input: AddProposalStageChecklistItemsInput) => {
    return addProposalStageChecklistItems({
      variables: {
        input,
      },
    });
  };

  return [addChecklistItems, { ...context, loading }] as const;
}
